import { SundVaegtProgramDto } from '@/shared/interfaces/api/sundvaegt-interfaces';
import { fetchIStatus } from '@/shared/fetchIStatus';

export const getOrCreateSundVaegtProgram =
    async (): Promise<SundVaegtProgramDto> => {
        return await fetchIStatus<SundVaegtProgramDto, void>(
            '/api/sundvaegt/program',
            'GET',
        );
    };
